import state from "./moduleMenuState.js";
import mutations from "./moduleMenuMutations.js";
import actions from "./moduleMenuActions";
import getters from "./moduleMenuGetters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
